export default "__VITE_ASSET__DnuhqI3P__"